import { FieldSelect } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import noop from 'lodash/noop';
import memoize from 'memoize-one';
import { PureComponent } from 'react';

import { MATCH_BOOLEAN_DEFAULT_VALUE } from 'components/automations/components/constants';
import {
  MatchingRuleT,
  VariableScope,
} from 'components/automations/components/nodeTypes/types';
import { MinimalReduxFormPropsT } from 'utils/minimalReduxFormFieldComponentAdapter';

import styles from './matchBoolean.module.scss';

type PropsT = {} & MinimalReduxFormPropsT<MatchingRuleT['match']>;

const OPTIONS = [
  {
    name: 'True',
    id: 'true',
  },
  {
    name: 'False',
    id: 'false',
  },
];

const ACCEPTED_VALUES = ['true', 'false'];

export class MatchBoolean extends PureComponent<PropsT> {
  constructor(props: PropsT) {
    super(props);
    this.getInputAdaptor = memoize(this.getInputAdaptor);
  }

  @boundMethod
  onChange(value) {
    const { input } = this.props;

    input.onChange({
      scope: VariableScope.INPUT,
      values: [
        {
          value,
          meta: {
            label: OPTIONS.find((opt) => opt.id === value)?.name ?? '',
          },
        },
      ],
    });
  }

  getInputAdaptor(input: PropsT['input']) {
    const match = input.value?.values?.[0] || MATCH_BOOLEAN_DEFAULT_VALUE;

    return {
      ...input,
      onChange: this.onChange,
      onBlur: noop,
      onFocus: noop,
      value:
        !Array.isArray(match) && ACCEPTED_VALUES.includes(match?.value)
          ? match.value
          : 'true',
    };
  }

  render() {
    const { input, meta } = this.props;
    const inputAdaptor = this.getInputAdaptor(input);

    return (
      <FieldSelect
        className={styles.root}
        input={inputAdaptor}
        meta={{
          error: meta?.error,
          touched: meta?.touched,
        }}
        items={OPTIONS}
        dropdownProps={{ fixed: true }}
        noLabel
        noAlert
      />
    );
  }
}
